// import { ChevronRight } from "lucide-react";
import React from "react";
import { ASSETS_URL } from "../../utils/config";
import { DockIcon } from "lucide-react";
import { FileText } from "lucide-react";
const PolicyCard = ({ policy }: any) => {
  return (
    <a target="_blank" href={`${ASSETS_URL}${policy?.policyUrl}`} className="px-3 py-4 flex border-navgreen border-r-2 transition-all duration-300 transform hover:-translate-y-1 border-b-2 overflow-hidden shadow-[0_0_2px_rgba(0,0,0,0.15)] hover:shadow-md rounded-md gap-2 items-center">
      {/* <div className="text-sm">
        {policy?.icon}
      </div> */}
      <FileText/>
      <div className="flex-1">
        <p className="font-semibold font-poppins text-sm">{policy?.title}</p>
        <p className="font-normal text-sm text-deepTeal line-clamp-2">
          {policy?.description}
        </p>
        {/* <div className="flex justify-end pt-1 gap-1 text-deepTeal items-center">
          <button className="font-normal text-sm text-right flex items-end justify-end text-navgreen">
            View Policy
          </button>
          <ChevronRight className="text-deepTeal w-3 h-3" color="green" strokeWidth={2}/>
        </div> */}
      </div>
    </a>
  );
};

export default PolicyCard;